<template>
  <div>
    <ButtonView type="shaded" color="foreground" size="small" :active="active || editor.isActive('videoEmbed')" @click="active = true; content.url = editor.getAttributes('videoEmbed').url">
      <i class="fab fa-youtube fa-fw" style="font-size: 1.2em"></i>
    </ButtonView>
    <ModalView v-model:active="active">
      <template v-slot:body>
        <VideoEmbedFormView :editor="editor" @submit="active = false"/>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";
import VideoEmbedFormView from "./VideoEmbedFormView.vue";
import ModalView from "../../../../plugins/modal/ModalView.vue";

defineProps({
  editor: Object
});

const active = ref(false);

const content = ref({});

</script>